import React from 'react';
import {connect} from 'react-redux';
import { toggleSectionPopup, updateSection } from '../../actions';
import { fetchImageRatios } from '../../../images/thunks';
import { SECTION_TYPE_TEXT_COLUMNS_MULTIPLE_MEDIA } from '../../constants';
import {
    deleteItemImage,
    updateItemImage,
    updateItemImageCrop,
    updateItemImageCropRatio,
    updateItemImageCropThumb,
    updateItemImageMeta,
    updateItemText,
    updateSectionTitle,
    updateSectionSetting,
} from '../../sections/actions/text_columns_multiple_media';
import { fetchSectionSettings } from '../../../pages/settings/thunks';
import TextColumnsMultipleMediaSectionEdit from './text_columns_multiple_media_section_edit';

class TextColumnsMultipleMediaPopup extends React.Component {
    componentWillUpdate(nextProps) {
        if (
            nextProps.isPopupOpened === true &&
            this.props.isPopupOpened === false
        ) {
            this.props.fetchImageRatios();
            if (!this.props.allSectionSettings || this.props.allSectionSettings.length === 0) {
                this.props.fetchSectionSettings();
            }
        }
    }

    render() {
        const textSectionSettings = this.props.allSectionSettings.filter(
            setting => Number(setting.section_type_id) === SECTION_TYPE_TEXT_COLUMNS_MULTIPLE_MEDIA
        );

        return (
            <TextColumnsMultipleMediaSectionEdit
                sectionSettings={textSectionSettings}
                selectedSectionSettings={this.props.selectedSectionSettings}
                updateSectionSetting={this.props.updateSectionSetting}
                open={this.props.isPopupOpened}
                siteId={this.props.siteId}
                pageId={this.props.pageId}
                sectionId={this.props.sectionId}
                title={this.props.title}
                sectionItems={this.props.sectionItems}
                onUpdateTitleField={(title) =>
                    this.props.updateSectionTitle(title)
                }
                updateItemText={this.props.updateItemText}
                imageRatios={this.props.imageRatios.text}
                onUpdateImageField={(index, images) =>
                    this.props.updateItemImage(index, images[0])
                }
                onDeleteImageField={(index, image) =>
                    this.props.deleteItemImage(index, image)
                }
                onCropImage={(index, image, imageUrlBlob, imageBlobObject) => {
                    this.props.updateItemImageCrop(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onCropThumbImage={(
                    index,
                    image,
                    imageUrlBlob,
                    imageBlobObject
                ) => {
                    this.props.updateItemImageCropThumb(
                        index,
                        image,
                        imageUrlBlob,
                        imageBlobObject
                    );
                }}
                onImageCropRatioUpdate={(index, cropRatioId) => {
                    this.props.updateItemImageCropRatio(index, cropRatioId);
                }}
                onImageMetaUpdate={(index, imageMeta) => {
                    this.props.updateItemImageMeta(index, imageMeta);
                }}
                onHandleSubmit={() =>
                    this.props.updateSection(
                        this.props.pageId,
                        this.props.sectionId,
                        this.props.sectionData,
                        { sectionSettings: this.props.selectedSectionSettings }
                    )
                }
                onHandleClose={() => this.props.toggleSectionPopup(false)}
            />
        );
    }
}

const mapStateToProps = (state, props) => {
    const { data, sectionId, sectionSettings } = state.sections.textColumnsMultipleMedia;
    return {
        isPopupOpened: state.pageBuilder.isPopupOpened,
        imageRatios: state.images.ratios,
        sectionData: data,
        sectionId,
        sectionItems: data.text_columns_multiple_media,
        title: data.title,
        selectedSectionSettings: sectionSettings,
        allSectionSettings: state.sectionsSettings.sectionSettings,
    };
}

export default connect(
    mapStateToProps,
    {
        deleteItemImage,
        fetchImageRatios,
        updateItemText,
        updateItemImage,
        updateItemImageCrop,
        updateItemImageCropRatio,
        updateItemImageCropThumb,
        updateItemImageMeta,
        updateSection,
        updateSectionTitle,
        updateSectionSetting,
        toggleSectionPopup,
        fetchSectionSettings,
    }
)(TextColumnsMultipleMediaPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/text_columns_multiple_media_popup.js